/**
 * Solio Countdown Hero — countdown ticker (closed state only).
 *
 * Reads the ISO target from [data-countdown][data-next-drop-date], computes
 * the diff in JS (timezone-safe), updates days/hours/minutes every second.
 * No seconds shown — calmer feel.
 *
 * If the target falls in the past mid-session (page open across the drop
 * time), the timer freezes at 00 · 00 · 00. The server-side render handles
 * the "past on first load" case by emitting the fallback line instead.
 */
(function () {
  'use strict';

  var el = document.querySelector('[data-countdown]');
  if (!el) return;

  var iso    = el.getAttribute('data-next-drop-date');
  var target = new Date(iso).getTime();
  if (isNaN(target)) return;

  var dEl = el.querySelector('[data-countdown-days]');
  var hEl = el.querySelector('[data-countdown-hours]');
  var mEl = el.querySelector('[data-countdown-minutes]');

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var diff = target - Date.now();
    if (diff <= 0) {
      if (dEl) dEl.textContent = '00';
      if (hEl) hEl.textContent = '00';
      if (mEl) mEl.textContent = '00';
      clearInterval(interval);
      return;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
  }

  tick();
  var interval = setInterval(tick, 1000);
})();
